import { patch } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";
import { OnboardingState } from "./User";

interface UpdateOnboardingDto {
  markTourSeen?: string;
  dismissTip?: string;
  completed?: boolean;
}

type OnboardingResponse = { success: boolean; onboarding: OnboardingState };

const updateOnboarding = (
  body: UpdateOnboardingDto,
): Promise<ApiResponse<OnboardingResponse>> => {
  return patch<OnboardingResponse>("/user/self/onboarding", body, null);
};

/** Record that the user finished or skipped a tour. */
export const markTourSeen = (
  tourId: string,
  completed = false,
): Promise<ApiResponse<OnboardingResponse>> =>
  updateOnboarding({ markTourSeen: tourId, completed });

/** Record that the user dismissed a one-time tip. */
export const dismissTip = (
  tipId: string,
): Promise<ApiResponse<OnboardingResponse>> =>
  updateOnboarding({ dismissTip: tipId });
